<template>
    <span class="projectContent">
        <h1 class="projectTitle">
            Bubble Fantasy
        </h1>
        <h2 class="projectSubTitle">
           Course Work of BVW Created in Just Two Weeks
        </h2>
        <h4>
            Team Members:
        </h4>
        <p>
            Richie Zhu (Sound Designer + Producer), Xixi Huang (Artist), Jim Zhao (Technical Artist), <u>Bonny Wang</u> (Programmer),  Mike Xu (Programmer)
        </p>
        <h4>
            Description:
        </h4>
        <p>
            An enchanting VR game where players manipulate captivating bubbles and adorable ducks in a whimsical world.
            
        </p>
        <h4>
            Technologies Used:
        </h4>
        <p>
            Quest 3 (with passthrough) | 1 Player
        </p>
        <h4>
            Game Screenshots:
        </h4>
        <img width="80%" src="ImgOriginal/Bubble_Fail.png">
        <img width="80%" src="ImgOriginal/Bubble.jpg">
        <h4>
            Gameplay video:
        </h4>
        <iframe width="80%" height="315" src="https://www.youtube.com/embed/V2wR0PY7XsU?si=YXGt7bv_viK_zuLy" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
           
    </span>
  
</template>

<script>
export default {
    name:"Bubble"

}
</script>

<style>

</style>